<template>
<v-container>
    <v-row justify="center" v-if="loading">
        <Loading> </Loading>
    </v-row>
</v-container>
 
</template>

<script>
import { getAuth } from 'firebase/auth'
import Loading from "@/components/Loading";
export default {
    name: "Logout",
    components: { Loading },
    data(){
        return{
            loading: true
        }
    },
    async mounted() {
        getAuth().signOut() 
        .then(() => {
          sessionStorage.clear();
          this.$store.commit('auth/logout');
          alert("Thank you for using DASH!");
          this.$router.push('/login');
        })
        .catch((error) => {
          console.log(error);
        });  
        
    }
}
    
</script>

<style scoped>

</style>